import { render, staticRenderFns } from "./ActivityHoursUnconfirmedAlert.vue?vue&type=template&id=2a647449"
import script from "./ActivityHoursUnconfirmedAlert.vue?vue&type=script&lang=ts"
export * from "./ActivityHoursUnconfirmedAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a647449')) {
      api.createRecord('2a647449', component.options)
    } else {
      api.reload('2a647449', component.options)
    }
    module.hot.accept("./ActivityHoursUnconfirmedAlert.vue?vue&type=template&id=2a647449", function () {
      api.rerender('2a647449', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ActivityHoursUnconfirmedAlert.vue"
export default component.exports